module.exports = __webpack_public_path__ + "img/kiss-wink-heart.abe434c7.svg";